import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class WaterPressureSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.WaterPressureSensor,
    });
  }
}
